<template>
  <div class="login-container">
    <div class="login-main">
      <div class="login-left">
        <SvgIcon class="login-icon-logo" iconClass="logo"></SvgIcon>
        <div class="h1">
          <p>欢迎加入</p>
          <p>dHome创作者平台</p>
        </div>
        <div class="desc">
          在这里你可以发布案例，利用我们提供的平台资源将内容有效的传达给用户。
        </div>
      </div>
      <div class="login-right">
        <el-tabs v-model="activeName">
          <el-tab-pane label="验证码登录" name="message">
            <MessageLogin></MessageLogin>
          </el-tab-pane>
          <el-tab-pane label="密码登录" name="password">
              <PasswordLogin></PasswordLogin>
          </el-tab-pane>
          <el-tab-pane label="二维码登录" name="qrcode">
              <QrcodeLogin v-if="activeName === 'qrcode'"></QrcodeLogin>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import MessageLogin from "@/components/MessageLogin";
import PasswordLogin from "@/components/PasswordLogin";
import QrcodeLogin from "@/components/QrcodeLogin";
import SvgIcon from "@/components/SvgIcon";
export default {
  name: "Login",
  components: {
    MessageLogin,
    PasswordLogin,
    QrcodeLogin,
    SvgIcon
  },
  data() {
    return {
      activeName: "password",
    };
  },
  created() {
  }
};
</script>

<style lang="scss">


/* reset element-ui css */
.login-container {
  background: url("./../../assets/login-bg.png") no-repeat;
  background-size: cover;
}
.login-icon-logo{
  padding: 0 10px;
  background: #fff;
  font-size: 150px;
  border-radius: 30px;
  margin-bottom: 40px;
}
</style>

<style lang="scss" scoped>
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #eee;

.login-container {
  min-height: 100%;
  width: 100%;
  background-color: $bg;
  overflow: hidden;
  .login-main {
    width: 1140px;
    margin: 0 auto;
    margin-top: 15%;
    display: flex;
    justify-content: space-between;
    .login-form{
        padding-top: 30px;
    }
    .login-left {
      flex: 1;
      margin-right: 257px;
          color: #fff;
      .h1{
          margin-top: 20px;
          font-size: 38px;
          line-height: 53px;
      }
      .desc{
          line-height: 33px;
          margin-top: 30px;
          font-size: 18px;
      }
    }
    .login-right {
      width: 440px;
      background: #fff;
      padding: 40px;
    }
  }
}
</style>
